import { useContext } from 'react';
import AuthContext from 'src/contexts/JWTContext';
import { PermissionLevel } from 'src/types/profilePermission';
import type { SystemModules } from 'src/types/systemModules';

const useClaims = (systemModule: SystemModules) => {
  const { user } = useContext(AuthContext);
  if (!user) return PermissionLevel.None;
  if (!user.claims) return PermissionLevel.None;
  return user.claims[systemModule] === undefined
    ? PermissionLevel.None
    : user.claims[systemModule];
};

export default useClaims;
